import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Send } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EnquiryForm({ eventId, eventTitle }) {
  const { t } = useLang();
  const [form, setForm] = useState({ name: "", email: "", phone: "", company: "", message: "", enquiry_type: "hospitality_request" });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) return;
    setLoading(true);
    try {
      await axios.post(`${API}/enquiry`, { ...form, event_id: eventId || null, event_title: eventTitle || null });
      toast.success(t("enquiry_success") || "Enquiry sent!");
      setForm({ name: "", email: "", phone: "", company: "", message: "", enquiry_type: "hospitality_request" });
    } catch { toast.error("Something went wrong."); }
    finally { setLoading(false); }
  };

  const inputCls = "w-full bg-[#141414] border border-[#262626] px-5 py-3.5 text-white font-['Outfit'] font-light text-sm placeholder:text-white/25 focus:outline-none focus:border-[#C5A059]/50 transition-colors";

  return (
    <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}>
      <form onSubmit={handleSubmit} data-testid="enquiry-form" className="space-y-4">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <input type="text" name="name" value={form.name} onChange={handleChange} placeholder={t("enquiry_name")} required data-testid="enquiry-name-input" className={inputCls} />
          <input type="email" name="email" value={form.email} onChange={handleChange} placeholder={t("enquiry_email")} required data-testid="enquiry-email-input" className={inputCls} />
          <input type="tel" name="phone" value={form.phone} onChange={handleChange} placeholder={t("enquiry_phone")} data-testid="enquiry-phone-input" className={inputCls} />
          <input type="text" name="company" value={form.company} onChange={handleChange} placeholder={t("enquiry_company")} data-testid="enquiry-company-input" className={inputCls} />
        </div>
        <select name="enquiry_type" value={form.enquiry_type} onChange={handleChange} data-testid="enquiry-type-select" className={`${inputCls} appearance-none`}>
          <option value="hospitality_request">{t("enquiry_type_hospitality")}</option>
          <option value="event_buyer">{t("enquiry_type_buyer")}</option>
          <option value="sponsor_interest">{t("enquiry_type_sponsor")}</option>
          <option value="reseller_agent">{t("enquiry_type_reseller")}</option>
          <option value="general">{t("enquiry_type_general")}</option>
        </select>
        <textarea name="message" value={form.message} onChange={handleChange} placeholder={t("enquiry_message")} required rows={4} data-testid="enquiry-message-input" className={`${inputCls} resize-none`} />
        <button type="submit" disabled={loading} data-testid="enquiry-submit-btn"
          className="btn-primary w-full md:w-auto px-10 py-4 text-xs tracking-[0.15em] uppercase font-['Outfit'] flex items-center justify-center gap-2 disabled:opacity-50">
          {loading ? t("enquiry_sending") : t("enquiry_send")} {!loading && <Send size={14} />}
        </button>
      </form>
    </motion.div>
  );
}
